import React from "react"
import autobind from "class-autobind"
import { TextField, Dialog, FlatButton, RaisedButton, SelectField, MenuItem, Toggle, Divider } from "material-ui"
import DoubleField from "../common/DoubleField"
import strings from "../../localization/strings"
import AccountStore from "../../stores/AccountStore"
import * as utils from "../../helpers/utils"
import * as taskHelper from "../../helpers/taskHelper"
import * as colorPickerUtil from "../../components/common/ColorPicker"
import { IPosition, IPositionTask, IPayClass, IPayrollPayGroupData, IDate } from "../../models"
import PositionColor from "./PositionColor"
import PositionTask from "./position_task/PositionTask"
import PayClass from "./pay_class/PayClass"
import * as permissionHelper from "../../helpers/permissionHelper"
import AuthenticationStore from "../../stores/AuthenticationStore"
import * as payGroupAndTypeHelper from "../../helpers/payGroupAndTypeHelper"
import accountStore from "../../stores/AccountStore"
import * as timeHelper from "../../helpers/timeHelper"
import IconDatePicker from "../common/IconDatePicker"
import moment from "moment"
import { string } from "prop-types"
import { checkPositionFieldAvailable } from "../../helpers/positionHelper"

interface IProps {
    readonly?: boolean

    // it true, it's AccountPositionDefinition dialog
    isDefinition?: boolean
    // for example, if add the job position, it "client positions"
    usablePositionLabel?: string
    // for example, if add the job position, it's client's positions
    usablePositions: IPosition[]
    // it's need for checking duplicated
    existPositions: IPosition[]
    editPosition: IPosition
    onRequestClose(): void
    onRequestSave(position: IPosition): void

	//we need isEmployeePosition for ForceAccountPositon
	isEmployee?: boolean
	//we need employee payroll to define employee->position->paytypes
	payrollPayGroupData?: IPayrollPayGroupData

	//we don't need Start/End dates for schedule->add shift -> SelectPosition chip
	ignoreDates?: boolean
}
interface IState {
	name: string
	errorName: string
	description: string
	costCenter: string
	errorCostCenter: string
	optionalTasks: IPositionTask[]
	requiredTasks: IPositionTask[]
	candidateClonePosition: IPosition
	clonePosition: IPosition
	payRate: string
	billRate: string
	color: string
	payTypeId: string
	errorPayTypeId: string
	usePayClasses: boolean
	defaultPayClass: IPayClass
	availablePayClasses: IPayClass[]
	hideOnMobile: boolean
	startDate: IDate
	endDate: IDate
	errorDates: string
}

export default class AddPositionDialog extends React.Component<IProps, IState> {
	private forceEmployeeAccountPosition = false
	constructor(props: IProps) {
		super(props)
		const startDateUTCFormat = props.editPosition && props.editPosition.StartDate ? timeHelper.convertDefaultDateToNull(props.editPosition.StartDate) : null
		const endDateUTCFormat = props.editPosition && props.editPosition.EndDate ? timeHelper.convertDefaultDateToNull(props.editPosition.EndDate) : null
		this.state = {
			name: props.editPosition ? props.editPosition.Name : "",
			errorName: "",
			description: props.editPosition && props.editPosition.Description ? props.editPosition.Description : "",
			costCenter: props.editPosition ? props.editPosition.CostCenter : "",
			errorCostCenter: "",
			requiredTasks: props.editPosition && props.editPosition.RequiredTasks ? props.editPosition.RequiredTasks : [],
			optionalTasks: props.editPosition && props.editPosition.OptionalTasks ? props.editPosition.OptionalTasks : [],
			payRate: props.editPosition && props.editPosition.PayInfo ? String(props.editPosition.PayInfo.PayRate) : "",
			billRate: props.editPosition && props.editPosition.PayInfo ? String(props.editPosition.PayInfo.BillRate) : "",
			color: props.editPosition ? props.editPosition.Color : AccountStore.getScheduleEnabled() ? colorPickerUtil.getDefaultColor(props.existPositions) : null,
			payTypeId: props.editPosition ? props.editPosition.PayTypeId : null,
			errorPayTypeId: "",
			candidateClonePosition: null,
			clonePosition: null,
			usePayClasses: props.editPosition && props.editPosition.AvailablePayClasses && props.editPosition.AvailablePayClasses.length > 0,
			defaultPayClass: props.editPosition ? props.editPosition.DefaultPayClass : null,
			availablePayClasses: props.editPosition && props.editPosition.AvailablePayClasses ? props.editPosition.AvailablePayClasses.filter(item => !item.Deleted) : [],
			hideOnMobile: props.editPosition ? props.editPosition.HideOnMobile : false,
			startDate: startDateUTCFormat ? timeHelper.keepConvertUTCToLocal(startDateUTCFormat) : null,
			endDate: endDateUTCFormat ? timeHelper.keepConvertUTCToLocal(endDateUTCFormat) : null,
			errorDates: ""
		}
		autobind(this)
		this.forceEmployeeAccountPosition = props.isEmployee && AccountStore.getForceEmployeeAccountPosition()
	}

                   handleRequestSave() {
                       if (!this.checkValidate()) return
                       const newId = utils.guid()
                       const position: IPosition = {
                           Id: this.props.editPosition ? this.props.editPosition.Id : newId,
                           BasePositionId: this.props.editPosition ?
				this.props.editPosition.BasePositionId :
				!this.props.isDefinition && this.state.clonePosition ?
					this.state.clonePosition.BasePositionId :
					newId,
                           Copied: this.props.editPosition ?
				this.props.editPosition.Copied :
				!this.props.isDefinition && this.state.clonePosition ?
					true : false,
                           Name: this.state.name.trim(),
                           Description: this.state.description && this.state.description.trim(),
                           CostCenter: this.state.costCenter && this.state.costCenter.trim(),
                           OptionalTasks: this.state.optionalTasks,
                           RequiredTasks: this.state.requiredTasks,
                           PayInfo: this.state.usePayClasses ?
				null :
				!this.state.payRate && !this.state.billRate ?
					null :
					{
						PayRate: this.state.payRate ? Number(this.state.payRate) : null,
						BillRate: this.state.billRate ? Number(this.state.billRate) : null
					},
			Color: this.state.color,
			PayTypeId: this.state.usePayClasses ? null : this.state.payTypeId,
			DefaultPayClass: this.state.usePayClasses ? this.state.defaultPayClass : null,
			AvailablePayClasses: this.state.usePayClasses ? this.state.availablePayClasses : null,
			HideOnMobile: this.state.hideOnMobile,
			StartDate: this.state.startDate ? moment(this.state.startDate).utc(true).format() : null,
			EndDate: this.state.endDate ? moment(this.state.endDate).utc(true).format() : null
		}
		this.props.onRequestSave(position)
		this.props.onRequestClose()
	}

                   setErrorText(key, value) {
                       this.setState((state) => (state[key] = value))
                   }

                   checkValidate() {
                       let isValidate = true

                       if (!this.state.name.trim().length) {
                           this.setState({ errorName: strings.NameRequired })
                           isValidate = false
                       }
		else if (this.state.name.trim().length > 30) {
                           this.setState({ errorName: strings.The_name_cannot_be_longer_than })
                           isValidate = false
                       }
		else if (this.props.existPositions.filter(p => this.props.editPosition ? p.Id !== this.props.editPosition.Id : true).find((p) => p.Name === this.state.name.trim())) {
                           this.setState({ errorName: strings.The_name_must_be_unique })
                           isValidate = false
                       }
		else {
                           this.setState({ errorName: "" })
                       }

                       if (this.state.costCenter && this.state.costCenter.length && !this.state.costCenter.trim().length) {
                           this.setState({ errorCostCenter: strings.Cost_Center_should_not_consist_of_white_spaces })
                           isValidate = false
                       }
		else if (this.state.costCenter && this.state.costCenter.length > 10) {
                           this.setState({ errorCostCenter: strings.Cost_Center_cannot_be_longer_than })
                           isValidate = false
                       }
		else {
                           this.setState({ errorCostCenter: "" })
                       }

                       if (this.state.usePayClasses) {
                           if (!this.state.defaultPayClass || !this.state.availablePayClasses.length) {
                               isValidate = false
                           }
                       }

		if (this.state.startDate && this.state.endDate && moment(this.state.startDate).isSameOrAfter(this.state.endDate)) {
			this.setState({ errorDates: strings.Invalid_date_range })
			isValidate = false
		}
		else {
			this.setState({ errorDates: "" })
		}
		return isValidate
	}

                   handleCopyPosition() {
                       this.setState({
                               name: this.state.clonePosition ? this.state.clonePosition.Name : "",
                               costCenter: this.state.clonePosition ? this.state.clonePosition.CostCenter : "",
                               description: this.state.clonePosition ? this.state.clonePosition.Description : "",
                               requiredTasks: this.state.clonePosition ? taskHelper.getTasksWithChangedGUID(this.state.clonePosition.RequiredTasks) : [],
                               optionalTasks: this.state.clonePosition ? taskHelper.getTasksWithChangedGUID(this.state.clonePosition.OptionalTasks) : [],
                               payRate: this.state.clonePosition && this.state.clonePosition.PayInfo ? String(this.state.clonePosition.PayInfo.PayRate) : "",
                               billRate: this.state.clonePosition && this.state.clonePosition.PayInfo ? String(this.state.clonePosition.PayInfo.BillRate) : "",
                               color: this.state.clonePosition ? this.state.clonePosition.Color : AccountStore.getScheduleEnabled() ? colorPickerUtil.getDefaultColor(this.props.existPositions) : null,
                               payTypeId: this.state.clonePosition ? this.state.clonePosition.PayTypeId : null,
                               usePayClasses: this.state.clonePosition && this.state.clonePosition.DefaultPayClass ? true : false,
                               defaultPayClass: this.state.clonePosition ? this.state.clonePosition.DefaultPayClass : null,
                               availablePayClasses: this.state.clonePosition ? this.state.clonePosition.AvailablePayClasses : [],
                               hideOnMobile: this.state.clonePosition ? this.state.clonePosition.HideOnMobile : false
                           }, () =>
			this.checkValidate()
                       )
                   }

                   render() {
                       const validUsablePositions = this.forceEmployeeAccountPosition ?
			[] :
			this.props.isDefinition ?
				this.props.usablePositions :
				this.props.usablePositions.filter(item => !this.props.existPositions.find(existItem => existItem.BasePositionId === item.BasePositionId))
                       const validPositionDefinitions = this.props.isDefinition ?
			[] :
			AccountStore.getCurrentAccount().PositionDefinitions.filter(item =>
                                     !this.props.existPositions.find(existItem => existItem.BasePositionId === item.BasePositionId) &&
                                     !this.props.usablePositions.find(existItem => existItem.BasePositionId === item.BasePositionId)
                             )
                       const availablePayTypeIds = this.props.isEmployee ?
			payGroupAndTypeHelper.getPayGroupByPayrollPayGroupData(this.props.payrollPayGroupData).LinkedPayTypeIds :
			AccountStore.getCurrentAccount().PayTypes.map(i => i.Id)
                       return (
                           <Dialog
                               open
                               title={
                                   this.props.readonly
                                       ? strings.Position
                                       : this.props.editPosition
                                       ?   checkPositionFieldAvailable('singular')  ? `Edit ${accountStore.getCurrentAccountSettings().CustomFieldSettings.PositionFieldLabels.SingularPositionLabel}` : strings.EditPosition
                                       : checkPositionFieldAvailable('singular') ? `Add New ${accountStore.getCurrentAccountSettings().CustomFieldSettings.PositionFieldLabels.SingularPositionLabel}` : strings.AddNewPosition
                               }
                               actions={
                                   this.props.readonly ?
                                       <FlatButton data-intercom-target={"Positions-Btn-CloseAddPostionDialog"} label={strings.Close} primary onTouchTap={this.props.onRequestClose} /> :
                                       [
                                           <FlatButton
                                               data-intercom-target={"Positions-Btn-CloseAddPostionDialog"}
                                               key="cancel"
                                               label={strings.CANCEL}
                                               secondary
                                               onTouchTap={this.props.onRequestClose}
                                           />,
                                           <FlatButton
                                               data-intercom-target={"Positions-Btn-AddOrSavePostion"}
                                               key="save"
                                               label={
                                                   this.props.editPosition
                                                       ? strings.Save
                                                       :checkPositionFieldAvailable('singular') ? `Add ${accountStore.getCurrentAccountSettings().CustomFieldSettings.PositionFieldLabels.SingularPositionLabel}` : strings.AddPosition
                                               }
                                               primary
                                               onTouchTap={this.handleRequestSave}
                                           />
                                       ]
                                                                  }
                               bodyStyle={{ padding: "0 20px", minHeight: 435 }}
							   contentStyle={ AccountStore.getUseBasePayRateInPayClassEnabled() && {maxWidth:"1024px"}}
                           >
                               <div style={{ minHeight: 435, maxHeight: "inherit", overflowY: "auto" }}>
                                   {!this.props.editPosition &&
						(validUsablePositions.length + validPositionDefinitions.length) > 0 &&
                                       <div style={{ display: "flex", flexWrap: "wrap" }}>
                                           <SelectField
                                               data-intercom-target={"Positions-Select-UsablePostions"}
                                               autoWidth
                                               floatingLabelText={checkPositionFieldAvailable("plural") ? `Usable ${accountStore.getCurrentAccountSettings().CustomFieldSettings.PositionFieldLabels.PluralPositionLabel}`: strings.Usable_Positions}
                                               value={this.state.candidateClonePosition}
                                               onChange={(event, index, value) => value ?
									this.setState({ candidateClonePosition: value }) :
									this.setState({ clonePosition: null, candidateClonePosition: null }, () =>
										this.handleCopyPosition()
									)
                                               }
                                           >
                                               {!this.props.isDefinition && !this.forceEmployeeAccountPosition && [
                                                       <MenuItem
										key="create_new"
										value={null}
										secondaryText={strings.Create_new}
									/>,
                                                       <Divider key="create_new_divider" />
                                                   ]}
                                               {validUsablePositions.map((item, i) => {
                                                   const positionName = item.CostCenter ? item.CostCenter + ": " + item.Name : item.Name
                                                   return (
                                                       <MenuItem
                                                           key={`usable_${i}`}
                                                           value={item}
                                                           primaryText={
                                                               <div
													className="TextOverflow"
													style={{ maxWidth: 250 }}
													title={positionName}
												>
                                                                   {positionName}
                                                               </div>
                                                           }
                                                           secondaryText={<div>{this.props.usablePositionLabel}</div>}
                                                       />
                                                   )
                                               })}
                                               {validUsablePositions.length > 0 && validPositionDefinitions.length > 0 &&
									<Divider />
								}
                                               {validPositionDefinitions.map((item, i) => {
                                                   const positionName = item.CostCenter ? item.CostCenter + ": " + item.Name : item.Name
                                                   return (
                                                       <MenuItem
                                                           key={`definition_${i}`}
                                                           value={item}
                                                           primaryText={
                                                               <div
													className="TextOverflow"
													style={{ maxWidth: 250 }}
													title={positionName}
												>
                                                                   {positionName}
                                                               </div>
                                                           }
                                                           secondaryText={<div>{validUsablePositions.length > 0 && strings.Account_Position}</div>}
                                                       />
                                                   )
                                               })}
                                           </SelectField>
                                           <RaisedButton
                                               data-intercom-target={"Positions-Btn-CopyOfPostion"}
                                               label={strings.COPY_OF}
                                               secondary
                                               onTouchTap={() => this.setState({ clonePosition: this.state.candidateClonePosition }, () =>
									this.handleCopyPosition()
								)}
                                               style={{ height: 35, marginLeft: 10, marginTop: 28 }}
                                           />
                                       </div>
                                   }
                                   <div style={{ display: "flex", flexWrap: "wrap" }}>
                                       <TextField
                                           data-intercom-target={"Positions-Entry-Name"}
                                           style={{ flex: 1 }}
                                           floatingLabelText={strings.Name}
                                           value={this.state.name}
                                           errorText={this.state.errorName}
                                           onChange={e => this.setState({ name: e.target.value }, () => this.checkValidate())}
                                           disabled={
                                               this.props.readonly ||
                                               this.forceEmployeeAccountPosition || (
									!this.props.isDefinition && (
										(this.props.editPosition && this.props.editPosition.Copied) ||
										this.state.clonePosition !== null
									)
								)
							}
						/>
						<TextField
							data-intercom-target={"Positions-Entry-CostCenter"}
							style={{ flex: 1, marginLeft: 10 }}
							floatingLabelText={strings.CostCenter}
							value={this.state.costCenter}
							errorText={this.state.errorCostCenter}
							onChange={e => this.setState({ costCenter: e.target.value }, () => this.checkValidate())}
							disabled={this.props.readonly || this.forceEmployeeAccountPosition}
						/>
						<TextField
							data-intercom-target={"Positions-Entry-Description"}
							style={{ flex: 1, marginLeft: 10 }}
							floatingLabelText={strings.Description}
							multiLine
							rows={1}
							rowsMax={4}
							value={this.state.description}
							onChange={e => this.setState({ description: e.target.value })}
							disabled={this.props.readonly || this.forceEmployeeAccountPosition}
						/>
					</div>
					{!this.props.ignoreDates &&
						<div style={{ display: "flex" }}>
							<div style={{ flex: 1 }}>
								<IconDatePicker
									optional
									label={strings.Start_Date}
									date={this.state.startDate}
									handleSelectDate={date => this.setState({ startDate: date ? moment(date).startOf("day") : null }, () => this.checkValidate())}
								/>
							</div>
							<div style={{ flex: 1 }}>
								<IconDatePicker
									optional
									label={strings.End_Date}
									date={this.state.endDate}
									errorText={this.state.errorDates}
									handleSelectDate={date => this.setState({ endDate: date ? moment(date).endOf("day") : null }, () => this.checkValidate())}
								/>
							</div>
							<div style={{ flex: 1 }} />
						</div>
					}
					<div style={{ display: "flex", marginTop: 10 }}>
						<div style={{ flex: 1 }}>
							<PositionTask
								readonly={this.props.readonly || this.forceEmployeeAccountPosition}
								requiredTasks={this.state.requiredTasks}
								optionalTasks={this.state.optionalTasks}
								handleAddRequiredTask={task => this.setState({ requiredTasks: [...this.state.requiredTasks, task] })}
								handleAddOptionalTask={task => this.setState({ optionalTasks: [...this.state.optionalTasks, task] })}
								hnadleDeleteRequiredTask={task => this.setState({ requiredTasks: this.state.requiredTasks.filter(item => item.Id !== task.Id) })}
								hnadleDeleteOptionalTask={task => this.setState({ optionalTasks: this.state.optionalTasks.filter(item => item.Id !== task.Id) })}
							/>
						</div>
						<div style={{ flex: 1, marginLeft: 10 }}>
							<PositionColor
								readonly={this.props.readonly || this.forceEmployeeAccountPosition}
								color={this.state.color}
								handleSelect={color => this.setState({ color })}
							/>
						</div>
						<div style={{ flex: 1, marginLeft: 10 }}>
							{AccountStore.getPayClassEnabled() &&
								<div>
									<Toggle
										data-intercom-target={"Positions-Toggle-UsePayClasses"}
										toggled={this.state.usePayClasses}
										onToggle={() => this.setState({ usePayClasses: !this.state.usePayClasses }, () => this.checkValidate())}
										labelPosition="left"
										label={strings.Use_Pay_Classes}
										style={{ maxWidth: 175, marginTop: 25 }}
										disabled={this.props.readonly || this.forceEmployeeAccountPosition}
									/>
								</div>
							}
						</div>
					</div>
					<div>
						<Toggle
							data-intercom-target={"Positions-Toggle-HideOnMobile"}
							toggled={this.state.hideOnMobile}
							onToggle={() => this.setState({ hideOnMobile: !this.state.hideOnMobile })}
							labelPosition="left"
							label={strings.Hide_On_Mobile}
							style={{ maxWidth: 175, marginTop: 25 }}
							disabled={this.props.readonly || this.forceEmployeeAccountPosition}
						/>
					</div>
					{this.state.usePayClasses ?
						<PayClass
							readonly={this.props.readonly || this.forceEmployeeAccountPosition}
							defaultPayClass={this.state.defaultPayClass}
							availablePayClasses={this.state.availablePayClasses}
							availablePayTypeIds={availablePayTypeIds}
							handleChange={(availablePayClasses, defaultPayClass) => this.setState({ availablePayClasses, defaultPayClass }, () => this.checkValidate())}
						/> :
						<div style={{ display: "flex" }}>
							{permissionHelper.hasPermission(AuthenticationStore.Permissions.Account.ViewRates) && [
								<div key="PayRate" style={{ flex: 1, display: "flex" }}>
									<span style={{ marginTop: 40, marginRight: 5 }}>$</span>
									<DoubleField
										name="PayRate"
										label={strings.Pay_Rate}
										value={this.state.payRate}
										style={{ width: "100%" }}
										handleChange={payRate => this.setState({ payRate })}
										readonly={this.props.readonly || this.forceEmployeeAccountPosition || !permissionHelper.hasPermission(AuthenticationStore.Permissions.Account.EditRates)}
									/>
								</div>,
								<div key="BillRate" style={{ flex: 1, marginLeft: 10, display: "flex" }}>
									<span style={{ marginTop: 40, marginRight: 5 }}>$</span>
									<DoubleField
										name="BillRate"
										label={strings.Bill_Rate}
										value={this.state.billRate}
										style={{ width: "100%" }}
										handleChange={billRate => this.setState({ billRate })}
										readonly={this.props.readonly || this.forceEmployeeAccountPosition || !permissionHelper.hasPermission(AuthenticationStore.Permissions.Account.EditRates)}
									/>
								</div>
							]}
							<div style={{ flex: 1, marginLeft: 10 }}>
								<SelectField
									data-intercom-target={"Positions-Select-PayType"}
									floatingLabelText={strings.Pay_Type}
									value={this.state.payTypeId}
									onChange={(event, index, value) => this.setState({ payTypeId: value }, () => this.checkValidate())}
									style={{ width: permissionHelper.hasPermission(AuthenticationStore.Permissions.Account.ViewRates) ? "100%" : "33%" }}
									errorText={this.state.errorPayTypeId}
									errorStyle={{ position: "absolute", bottom: -10 }}
									disabled={this.props.readonly || this.forceEmployeeAccountPosition}
								>
									<MenuItem
										value={null}
										primaryText=""
									/>
                                                   {AccountStore.getCurrentAccount().PayTypes
										.filter(i => availablePayTypeIds.includes(i.Id))
                                                       .map((item, i) =>
                                                           <MenuItem
												key={i}
												value={item.Id}
												primaryText={item.Name}
											/>
                                                       )}
                                               </SelectField>
                                           </div>
                                       </div>
                                   }
                               </div>
                           </Dialog>
                       )
                   }
               }